module.exports = __webpack_public_path__ + "media/components/Shared/QuestionMark/question_mark-7c9d8ea4e544175340a8ad35a8894ab7.svg";